import React, { FC } from 'react';
import { StatusFieldOption } from 'api/tasks';
import { Avatar } from 'components/atoms/avatar';
import { TeamsWithProjectAsLeafResource } from 'components/organisms/resource-management/resource-types';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { getThumbnailUrl } from 'utils/get-thumbnail-url';
import { ProjectStatusIndicator, TextWrapperWithEllipsis } from './component';
import { TeamWrapperWithActions } from './team-wrapper-with-actions';

type Props = Pick<
  TeamsWithProjectAsLeafResource,
  | 'projectName'
  | 'teamName'
  | 'customer'
  | 'projectId'
  | 'teamId'
  | 'autoAllocation'
> & {
  projectStatus?: StatusFieldOption;
  softAllocationsEnabled: boolean;
  onFindMember: () => void;
  onEditTeam: () => void;
  onDeleteAllocations: () => void;
  onConvertAllocations: (toSoft: boolean) => void;
  onTeamRemoval: (projectId: number, teamId: number) => void;
};

export const TeamCellForUsersView: FC<Props> = ({
  projectName,
  customer,
  teamName,
  projectId,
  teamId,
  projectStatus,
  softAllocationsEnabled,
  onFindMember,
  onEditTeam,
  onDeleteAllocations,
  onConvertAllocations,
  onTeamRemoval,
  autoAllocation,
}) => {
  return (
    <TeamWrapperWithActions
      projectId={projectId}
      teamId={teamId}
      softAllocationsEnabled={softAllocationsEnabled}
      onFindMember={onFindMember}
      onEditTeam={onEditTeam}
      onTeamRemoval={onTeamRemoval}
      onDeleteAllocations={onDeleteAllocations}
      onConvertAllocations={onConvertAllocations}
      autoAllocateProps={{ autoAllocation, showIcon: false }}
    >
      <NameCell
        logo={
          projectStatus != null ? (
            <ProjectStatusIndicator status={projectStatus} />
          ) : (
            <Avatar
              src={getThumbnailUrl(customer.companyLogoUrl)}
              name={projectName}
            />
          )
        }
        primaryText={
          <TextWrapperWithEllipsis>{projectName}</TextWrapperWithEllipsis>
        }
        secondaryText={
          <TextWrapperWithEllipsis>{teamName}</TextWrapperWithEllipsis>
        }
      />
    </TeamWrapperWithActions>
  );
};
